export default __webpack_public_path__ + "static/media/clip.44552a7d.svg";